// Velanox logo — hub & spoke mark + wordmark
// Based on the official Velanox brand system

export function LogoMark({ size = 28, color = 'currentColor', accent = 'var(--accent)' }: {
  size?: number; color?: string; accent?: string
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <circle cx="16" cy="16" r="3.5" fill={accent} />
      <circle cx="16" cy="4"  r="2"   fill={color} />
      <circle cx="28" cy="16" r="2"   fill={color} />
      <circle cx="16" cy="28" r="2"   fill={color} />
      <circle cx="4"  cy="16" r="2"   fill={color} />
      <line x1="16" y1="6"  x2="16" y2="12.5" stroke={color} strokeWidth="1.25" />
      <line x1="20" y1="16" x2="26"  y2="16"  stroke={color} strokeWidth="1.25" />
      <line x1="16" y1="20" x2="16"  y2="26"  stroke={color} strokeWidth="1.25" />
      <line x1="6"  y1="16" x2="12"  y2="16"  stroke={color} strokeWidth="1.25" />
    </svg>
  )
}

export function VelanoxLogo({ size = 24, showWordmark = true }: { size?: number; showWordmark?: boolean }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: showWordmark ? 9 : 0, color: 'var(--fg)' }}>
      <LogoMark size={size} color="var(--fg)" accent="var(--accent)" />
      {showWordmark && (
        <span style={{
          fontFamily: 'var(--font-display)',
          fontSize: size * 0.78,
          fontWeight: 600,
          letterSpacing: '-0.025em',
          color: 'var(--fg)',
        }}>
          velanox
        </span>
      )}
    </span>
  )
}
